// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ac-list {
  position: relative;
}

.ac-list ul,
.ac-list-status {
  background: var(--color-surface, #fff);
  border: 1px solid var(--color-border, #ddd);
  border-radius: 0 0 4px 4px;
  box-shadow: 0 4px 8px rgb(0 0 0 / 12%);
  left: 0;
  list-style: none;
  margin: 0;
  max-height: 240px;
  overflow-y: auto;
  padding: 0;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 20;
}

.ac-list li + li {
  border-top: 1px solid var(--color-border, #ddd);
}

.ac-list .ac-list-option {
  appearance: none;
  background-color: transparent;
  border: 0;
  border-radius: 0;
  box-shadow: none;
  box-sizing: border-box;
  color: var(--color-text, #263934);
  cursor: pointer;
  display: block;
  font: inherit;
  margin: 0;
  min-width: 0;
  padding: 10px 12px;
  text-align: left;
  width: 100%;
}

.ac-list .ac-list-option:hover,
.ac-list .ac-list-option:focus-visible {
  background-color: var(--color-hover-bg, #f3f3f3);
  color: var(--color-text, #263934);
  outline: none;
}

.ac-list-status {
  padding: 10px 12px;
}

.ac-list-error {
  color: var(--color-danger-text, #a12622);
}
`, "",{"version":3,"sources":["webpack://./src/components/AutocompleteList.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,sCAAsC;EACtC,2CAA2C;EAC3C,0BAA0B;EAC1B,sCAAsC;EACtC,OAAO;EACP,gBAAgB;EAChB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,WAAW;AACb;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,iCAAiC;EACjC,eAAe;EACf,cAAc;EACd,aAAa;EACb,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;;EAEE,gDAAgD;EAChD,iCAAiC;EACjC,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;AAC1C","sourcesContent":[".ac-list {\n  position: relative;\n}\n\n.ac-list ul,\n.ac-list-status {\n  background: var(--color-surface, #fff);\n  border: 1px solid var(--color-border, #ddd);\n  border-radius: 0 0 4px 4px;\n  box-shadow: 0 4px 8px rgb(0 0 0 / 12%);\n  left: 0;\n  list-style: none;\n  margin: 0;\n  max-height: 240px;\n  overflow-y: auto;\n  padding: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: 20;\n}\n\n.ac-list li + li {\n  border-top: 1px solid var(--color-border, #ddd);\n}\n\n.ac-list .ac-list-option {\n  appearance: none;\n  background-color: transparent;\n  border: 0;\n  border-radius: 0;\n  box-shadow: none;\n  box-sizing: border-box;\n  color: var(--color-text, #263934);\n  cursor: pointer;\n  display: block;\n  font: inherit;\n  margin: 0;\n  min-width: 0;\n  padding: 10px 12px;\n  text-align: left;\n  width: 100%;\n}\n\n.ac-list .ac-list-option:hover,\n.ac-list .ac-list-option:focus-visible {\n  background-color: var(--color-hover-bg, #f3f3f3);\n  color: var(--color-text, #263934);\n  outline: none;\n}\n\n.ac-list-status {\n  padding: 10px 12px;\n}\n\n.ac-list-error {\n  color: var(--color-danger-text, #a12622);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
